import React, { useRef } from 'react';

import TrainingRoadmaps from './TrainingRoadmaps';
import LearningJourney from './LearningJourney';
import WhyChooseTraining from './WhyChooseTraining';
import StudentRegistration from './StudentRegistration';
import UIBody from '../../../components/ui/UIBody';
import useApiCallHooks from '../../../hooks/useApiCallHooks';
import OverlayLoader from '../../../components/Common/OverlayLoader';

const heroImage = "";

const CampusToCorporate = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

  const formRef = useRef(null); // 🔹 Create ref for form

  // 🔹 Function to scroll to form section
  const scrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const content = (
  
    <div className="j-c2c-wrapper">
      <OverlayLoader show={loading} />

      {/* Intro Banner Section */}
      <div className="c2c-hero-section py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Text Content */}
            <div className="col-md-6 text-center text-md-start">
              <h1 className="fw-bold display-4 mb-3">
                Your <span className="c2c-text-gradient">Career Journey Starts</span> 
                <span className="display-5 ms-2 fw-bold">Here</span>
              </h1>

              <p className="lead text-muted fs-5 mb-4">
               Campus to Corporate training programs designed for students at any stage. Choose your roadmap, learn at your pace,
                and transform into an industry-ready professional with guaranteed job placement.
              </p>

              <div className="d-flex justify-content-center justify-content-md-start gap-3 flex-wrap">
              
                <button className="btn btn-outline-dark fw-semibold " onClick={scrollToForm}>
                  Register Now
                </button>
              </div>
            </div>

            {/* Hero Image */}
            <div className="col-md-6 mt-5 mt-md-0 text-center">
              <img
                src={"/images/ui/programe-step/IT/C2C.jpeg"}
                alt="Career Journey"
                className="img-fluid c2c-hero-image"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Other Sections */}
      <div className="c2c-section">
        <TrainingRoadmaps onStartClick={scrollToForm} /> {/* 🔹 Pass to Roadmap */}
      </div>
      <div className="c2c-section-lg">
        <LearningJourney />
      </div>
      <div className="c2c-section">
        <WhyChooseTraining onStartClick={scrollToForm} /> {/* 🔹 Pass to WhyChooseTraining */}
      </div>
      <div className="c2c-section" ref={formRef}> {/* 🔹 Reference for scroll */}
        <StudentRegistration />
      </div>
    </div>
  );

  return <UIBody content={content} />;
};

export default CampusToCorporate;
